import api from '../../../App/socket';

export const getBikeModelOverview = (limit, offset, ref_bike_model) => (
    api.send({
        api: 'db',
        model: 'Bike_inventory',
        action: 'Read',
        options: {
            attributes: ['year', 'mileage', 'purchase_date', 'price.purchase_price',
                'price.gross_margin', 'price.net_margin', 'price.retail_price', 'inventory_status'],
            limit,
            offset,
            include: [
                {
                    model: 'Bike_brand',
                    attributes: 'all',
                },
                {
                    model: 'Bike_model',
                    attributes: ['name', 'year'],
                },
            ],
            whereff: {
                ref_bike_model,
            },
        },
    }).then(response => response.options).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/requests/get_bike_model_overview_request.js